import { Box, Divider, Typography, styled } from "@mui/material";
import { CustomDisplayItem } from "@/components/custom/custom-display-item";
import { DocumentLink } from "@/utils/format-document-link";

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("lg")]: { flexDirection: "row" },
}));

const Grid = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),
  [theme.breakpoints.up("md")]: { gridTemplateColumns: "1fr 1fr" },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: { width: 256 },
}));

const SectionTitle = ({ title, description }) => (
  <Side>
    <Typography fontWeight={500} fontSize={18}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    )}
  </Side>
);

const KycDirectorInfo = ({ directors = [] }) => {
  if (!directors.length) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      {directors.map((dir, index) => (
        <Box key={dir.id ?? index}>
          {index > 0 && <Divider sx={{ mb: 3 }} />}
          <Row>
            <SectionTitle
              title={`Director ${directors.length > 1 ? index + 1 : ""} Information`.trim()}
              description="Details of the registered business director."
            />
            <Grid>
              <Box>
                <CustomDisplayItem label="First Name" value={dir?.firstName} />
              </Box>
              <Box>
                <CustomDisplayItem label="Last Name" value={dir?.lastName} />
              </Box>
              <Box>
                <CustomDisplayItem label="NIN Number" value={dir?.ninNumber} />
              </Box>
              <Box>
                <CustomDisplayItem label="BVN Number" value={dir?.bvnNumber} />
              </Box>
              <Box>
                <CustomDisplayItem
                  label="NIN Approved"
                  value={dir?.ninApproved ? "Yes" : "No"}
                />
              </Box>
              <Box>
                <CustomDisplayItem
                  label="BVN Approved"
                  value={dir?.bvnApproved ? "Yes" : "No"}
                />
              </Box>
              <DocumentLink label="Director Photo" url={dir?.directorPhotoUrl} />
              <DocumentLink label="Director NIN Image" url={dir?.directorNinImageUrl} />
            </Grid>
          </Row>
        </Box>
      ))}
    </Box>
  );
};

export default KycDirectorInfo;